import dayjs from 'dayjs';

export default ({ $auth, $config, route }) => {
  /**
   * Redirect the user according to his role
   */
  let location = '';
  let changeDashboard = false;
  // 2020-09-29T12:00:00+00:00
  const migrationDate = dayjs('2020-09-29T12:00:00+00:00');
  const beforeMigration = dayjs($auth?.user?.attributes?.created_at).isBefore(migrationDate);
  const isVerified = !!$auth.user?.attributes?.email_verified_at;
  const isValidateEmail = beforeMigration || isVerified;
  // logged in
  if ($auth?.user) {
    const userRoles = $auth?.user?.relationships?.roles?.data;
    const operator = !!userRoles?.find(({ id }) => id === 6);
    const customer = !!userRoles?.find(({ id }) => id === 3);
    const staff = !!userRoles?.find(({ id }) => ![6, 3].includes(id));

    if (!operator) {
      changeDashboard = true;
      if (customer) {
        location = $config.ocusClientUrl;
      }

      if (staff) {
        location = $config.ocusStaffUrl;
      }
    }

    // user is a logged operator
    if (!changeDashboard) {
      if (!isValidateEmail
        && !route.path.includes('/auth/verify-email/')
        && !beforeMigration
      ) {
        location = '/auth/verify-email/pending';
      }
      if (!$auth.user?.attributes?.welcomed && !route.path.includes('/auth/tos') && isValidateEmail) {
        location = '/auth/tos';
      }
    }
  }

  // not logged in
  if (!changeDashboard) {
    if (route.path.includes('/invitations/')) {
      const chunks = route.path.split('/');
      const token = chunks[chunks.length - 1];
      location = `/auth/signup?token=${token}`;
    }
  }

  if (location !== '') {
    window.location.href = location;
  }
};
